import React from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../services/L10n';
import StopPropagation from '../utils/StopPropagation';
import { KompisPrompt, KompisText } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { actionCloseDialog } from '../../state/dialog/dialogActions';
import { actionSetOverlayState } from '../../state/popups/popupsActions';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';
import { useKioskIntegration } from '../../hooks/useKioskIntegration';
import { t } from '../../translations';

const IpexGalleryWarning = () => {
  const dispatch = useDispatch();
  const { integration } = useKioskIntegration();
  const [showPrompt, setShowPrompt] = React.useState(true);

  const onButtonClick = (event: any) => {
    setShowPrompt(false);
    if (event.detail.type === PromptButtonTypeEnum.primaryButton) {
      integration?.exitClicked();
    } else {
      close();
    }
  };

  /**
   * Close modal
   */
  const close = (): void => {
    dispatch(actionCloseDialog());
    dispatch(actionSetOverlayState(false));
  };

  return (
    <StopPropagation>
      <KompisPrompt
        heading={translate(t.IPEX_GALLERY_EXIT_DIALOGUE_HEADLINE)}
        primaryButtonLabel={translate(t.IPEX_GALLERY_EXIT_DIALOGUE_EXIT_BUTTON)}
        secondaryButtonLabel={translate(
          t.IPEX_GALLERY_EXIT_DIALOGUE_CONTINUE_BUTTON
        )}
        onButtonClick={onButtonClick}
        visible={showPrompt}
        theme={SkapaTheme}
      >
        <KompisText theme={SkapaTheme}>
          {translate(t.IPEX_GALLERY_EXIT_DIALOGUE_BODY)}
        </KompisText>
      </KompisPrompt>
    </StopPropagation>
  );
};

export default IpexGalleryWarning;
